/* eslint-disable react/jsx-pascal-case */
import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { useDispatch, useSelector } from 'store'
import * as LoginAction from 'slicers/LoginSlice'
import * as PageAction from 'slicers/PageSlice'
import * as SearchUserAction from 'slicers/SearchSlicers/SearchUserSlice'
import { labels } from 'types/ReferTypes'
import T_Main from 'components/4_Templates/T_Main'
import { getMenuLabel } from 'utils/stringUtil'
import C3_UserToroku from './Contents/C4_UserToroku'

const P_UserToroku = ({ labels }: { labels: labels }) => {
  // ログインユーザーの種類(0: ジャペル, 1: 仕入先)
  const loginKbn = useSelector((state) => state.LoginReducer.loginKbn)
  const isJapell = useSelector((state) => state.LoginReducer.isJapell)
  const isSuper = useSelector((state) => state.LoginReducer.isSuper)
  const keyInfo = useSelector((state) => state.LoginReducer.keyInfo)
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    if (loginKbn !== 2 || !isJapell) {
      dispatch(LoginAction.format())
      history.push('/') // ログイン画面に遷移
    } else {
      dispatch(PageAction.deleteMessage())
      dispatch(SearchUserAction.initialize({ isSuper: isSuper, JIGYO_CD: keyInfo[0].JIGYO_CD })) // 初期状態に設定
    }
  }, [])

  return (
    <T_Main labels={labels} pageTitle={getMenuLabel(labels.sideMenus[2])}>
      <C3_UserToroku />
    </T_Main>
  )
}

export default P_UserToroku
